import { render, staticRenderFns } from "./Tarrifs.vue?vue&type=template&id=0a2edbae"
import script from "./Tarrifs.vue?vue&type=script&lang=ts"
export * from "./Tarrifs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports